import requests from '../shared/agent';

const endpoint = '/missions';

const MissionService = {
    getAll: async() => {
        return await requests.get(endpoint);
    },
    getById: async(id) => {
        return await requests.get(`${endpoint}/${id}`);
    },
    create: async(mission) => {
        return await requests.post(endpoint, mission);
    },
    edit: async(id, mission) => {
        return await requests.put(`${endpoint}/${id}`, mission)
    },
    changeActive: async(id, status) => {
        return await requests.post(`${endpoint}/${id}/active`, status)
    },
    remove: async(id) => {
        return await requests.del(`${endpoint}/${id}`);
    }
};

export default MissionService;

